import Layout from '@/components/layout/index.vue'

export default {
  path: 'performance',
  name: 'Performance',
  meta: { title: '绩效' },
  component: Layout,
  redirect: { name: 'Performance.Rate' },
  children: [
    {
      path: 'rate',
      name: 'Performance.Rate',
      meta: {},
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/rate/index.ts')
    },
    {
      path: 'rate/add',
      name: 'Performance.Rate.Add',
      meta: { title: 'routes.performance.rateAdd', dep: 'Performance.Rate' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/rate/add.ts')
    },
    {
      path: 'rate/modify/:id',
      name: 'Performance.Rate.Modify',
      meta: { title: 'routes.performance.rateModify', dep: 'Performance.Rate' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/rate/modify.ts')
    },
    {
      path: 'qualitative-project',
      name: 'Performance.QualitativeProject',
      meta: {},
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/qualitative-project/index.ts')
    },
    {
      path: 'qualitative-project/add',
      name: 'Performance.QualitativeProject.Add',
      meta: { title: 'common.add', dep: 'Performance.QualitativeProject' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/qualitative-project/add.ts')
    },
    {
      path: 'qualitative-project/modify/:id',
      name: 'Performance.QualitativeProject.Modify',
      meta: { title: 'common.modify', dep: 'Performance.QualitativeProject' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/qualitative-project/modify.ts')
    },
    {
      path: 'qualitative-formula',
      name: 'Performance.QualitativeFormula',
      meta: {},
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/qualitative-formula/index.ts')
    },
    {
      path: 'qualitative-formula/add',
      name: 'Performance.QualitativeFormula.Add',
      meta: { title: 'common.add', dep: 'Performance.QualitativeFormula' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/qualitative-formula/add.ts')
    },
    {
      path: 'qualitative-formula/modify/:id',
      name: 'Performance.QualitativeFormula.Modify',
      meta: { title: 'common.modify', dep: 'Performance.QualitativeFormula' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/qualitative-formula/modify.ts')
    },
    {
      path: 'formula-config',
      name: 'Performance.FormulaConfig',
      meta: {},
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/formula-config/index.ts')
    },
    {
      path: 'formula-config/add',
      name: 'Performance.FormulaConfig.Add',
      meta: { title: 'common.add', dep: 'Performance.FormulaConfig' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/formula-config/add.ts')
    },
    {
      path: 'formula-config/modify/:id',
      name: 'Performance.FormulaConfig.Modify',
      meta: { title: 'common.modify', dep: 'Performance.FormulaConfig' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/formula-config/modify.ts')
    },
    {
      path: 'number-formula',
      name: 'Performance.NumberFormula',
      meta: {},
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/number-formula/index.ts')
    },
    {
      path: 'number-formula/add',
      name: 'Performance.NumberFormula.Add',
      meta: { title: 'common.add', dep: 'Performance.NumberFormula' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/number-formula/add.ts')
    },
    {
      path: 'number-formula/modify/:id',
      name: 'Performance.NumberFormula.Modify',
      meta: { title: 'common.modify', dep: 'Performance.NumberFormula' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/number-formula/modify.ts')
    },
    {
      path: 'supplier-formula',
      name: 'Performance.SupplierFormula',
      meta: {},
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/supplier-formula/index.ts')
    },
    {
      path: 'performancequery',
      name: 'Performance.Performancequery',
      meta: {},
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/performancequery/index.ts')
    },
    {
      path: 'qualitativescore',
      name: 'Performance.Qualitativescore',
      meta: {},
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/qualitativescore/index.ts')
    },
    {
      path: 'qualitativescore/score/:id',
      name: 'Performance.Qualitativescore.Score',
      meta: { title: 'performance.qualitativescore.score', dep: 'Performance.Qualitativescore' },
      component: () => import(/* webpackChunkName: "performance" */ '@/views/purchaser/performance/qualitativescore/score.vue')
    }
  ]
}
